import { createApp } from 'vue'
import { createHead } from '@vueuse/head'
import { MotionPlugin } from '@vueuse/motion'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { localizePrice } from './utils/currency'
import { initClickTracking } from './utils/analytics'

import './assets/styles/main.css'

// Crear una nueva instancia de la aplicación Vue
const app = createApp(App)

// Registra localizePrice como propiedad global para poder llamarla desde
// cualquier plantilla como $localizePrice(texto, locale), sin tener que
// importarla en cada componente que muestra un precio.
app.config.globalProperties.$localizePrice = localizePrice

// Manejo de <head> (title, meta, canonical) por página
const head = createHead()

// Usar plugins
app.use(router)
app.use(i18n)
app.use(head)
app.use(MotionPlugin)

// Eventos de GA4: clics a WhatsApp, correo y teléfono (ver utils/analytics.js)
initClickTracking()

// Montar la aplicación
app.mount('#app')